module.exports = __webpack_public_path__ + "static/violet_black-f1004ada210ea6c9dd3fab4aef733ce6.png";